<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { on, off } from "view-design/src/utils/dom";
import { setMatchMedia } from "view-design/src/utils/assist";
import { mapMutations, mapState } from "vuex";
import { formatDate } from "@/libs/common";
import router from "@/router";
import { logout } from "@api/softTelStrip";
import $ from "@/libs/jquery-1.7.1.min";
import agentuc from "@/libs/agentuc";

setMatchMedia();

export default {
  name: "app",
  data() {
    return {
      beforeUnloadTime: "",
      unloadTime: "",
      opcall: null,
      //坐席信息
      seatPost: {},
      // 按钮状态
      refreshState: {
        isCheck: false, //是否登录
        isLeisure: false, //是否示闲
        isDial: false, //是否在通话中
        isHold: false, //是否保持
      },
    };
  },
  computed: {
    // 使用计算属性从store获取数据
    ...mapState("admin/user", ["info"]),
  },
  created() {
    this.updatePageTitle();
  },
  methods: {
    ...mapMutations("admin/layout", ["setDevice"]),
    // 修改网页标题
    updatePageTitle() {
      let loginType = null;
      const hash = window.location.hash;
      const queryIndex = hash.indexOf("?");

      if (queryIndex !== -1) {
        // 截取 ? 后面的字符串，使用 URLSearchParams 解析
        const queryString = hash.substring(queryIndex + 1);
        const params = new URLSearchParams(queryString);
        loginType = params.get("loginType");
      }

      const title1 = process.env.VUE_APP_TITLE || "南康区民意速办综合管理平台";
      const title2 = process.env.VUE_APP_ZZ_TITLE;

      // 综治中心用户，动态修改 title
      document.title = loginType === "zz" ? title2 : title1;
    },

    handleWindowResize() {
      this.handleMatchMedia();
    },
    handleMatchMedia() {
      const matchMedia = window.matchMedia;

      if (matchMedia("(max-width: 600px)").matches) {
        this.setDevice("Mobile");
      } else if (matchMedia("(max-width: 992px)").matches) {
        this.setDevice("Tablet");
      } else {
        this.setDevice("Desktop");
      }
    },
    //初始化话务条
    initStrip(queueId) {
      const { sysSeatsConfig, sysCallCenterConfig } = this.info;
      const seatPostLogin = JSON.parse(
        window.localStorage.getItem("seatPostLogin"),
      );
      //  let  login_queue = $("#login_queue").val();
      //将IP和账号密码替换为实际的IP和账号、密码
      //let  cti_config={debug: true, baseurl: "https://59.231.74.171/atstar/client.php", user: user, password: password, login_ext_no: login_ext_no}
      //密码登录方式
      const cti_config = {
        debug: true,
        //baseurl: "http://106.227.89.82:1900/atstar/client.php",
        baseurl: sysCallCenterConfig.configUrl + "/atstar/client.php",
        user: sysSeatsConfig.userName,
        password: sysSeatsConfig.password,
        login_ext_no: sysSeatsConfig.loginExtNo,
        login_queue: queueId || seatPostLogin.queueId,
      };
      //sso_token登录方式:系统也可以通过sso_token登录，sso_token通过后端接口/user-interface/ssoticket获取
      //let  cti_config={debug: true, baseurl: "http://192.168.2.115/atstar/client.php", user: user, sso_token: "976a96a34fd60d433cb74e3388d62526", login_ext_no: login_ext_no, login_queue: login_queue}
      //let  cti_config={debug: true, baseurl: "http://192.168.3.8/atstar/client.php", user: user, password: password, login_ext_no: login_ext_no};
      const opcall = new call(cti_config);
      //事件监听
      // this.bind_event(opcall)
      this.opcall = { ...opcall };
    },
    bind_event(opcall) {
      const { sysSeatsConfig } = this.info;
      const _this = this;
      opcall.lib
        .event("login")
        .unsubscribe()
        .subscribe(function() {
          console.log("坐席登录成功，分机号：" + opcall.cfg.ext_no);
          console.log("坐席登录成功，opcall" + JSON.stringify(opcall));
          _this.seatPost = { ...opcall.cfg };
          _this.refreshState = { ..._this.refreshState, isDial: false };
        });

      opcall.lib
        .event("logout")
        .unsubscribe()
        .subscribe(function() {
          console.log("坐席登出成功");
          _this.seatPost = {};
          _this.refreshState = {
            isCheck: false, //是否登录
            isLeisure: false, //是否示闲
            isDial: false, //是否在通话中
            isHold: false, //是否保持
          };
        });

      opcall.lib
        .event("login_fail")
        .unsubscribe()
        .subscribe(function(data) {
          console.log("登录失败：" + data.message);
          _this.$set(_this.seatPost, "status", "离线");
        });

      opcall.lib
        .event("member_count")
        .unsubscribe()
        .subscribe(function(data) {
          _this.$set(_this.seatPost, "member_count", data);
        });

      opcall.lib
        .event("idle")
        .unsubscribe()
        .subscribe(function(ext) {
          console.log("坐席挂机空闲了：" + JSON.stringify(ext));
          _this.seatPost = { ..._this.seatPost, ...ext, status: "空闲" };
          _this.refreshState = {
            ..._this.refreshState,
            isDial: false,
            isLeisure: true,
          };
        });

      opcall.lib
        .event("ring")
        .unsubscribe()
        .subscribe(function(ext) {
          _this.seatPost = { ..._this.seatPost, ...ext, status: "振铃" };
          console.log(
            "电话振铃了[此处完成弹屏]，事件类型：" +
              ext.event +
              "来电号码" +
              ext.peer +
              "，IVR按键随路：" +
              ext.call_info +
              "，话单唯一编号:" +
              ext.cdr_uuid,
          );
          console.log(JSON.stringify(ext));
          const callData = {
            cdrUuid: ext.cdr_uuid,
            phone: ext.peer,
            callTime: formatDate(new Date()),
          };
          //打入电话弹屏-新建工单
          if (ext.direction == "in") {
            //如果未允许弹屏之前，不设置弹出标记，等下次振铃可正常弹屏
            //console.log('window.open()',window.open())
            /* if (window.open()) {
             window.localStorage.setItem("isRing", true)
           }
           const routeData = router.resolve({
             path: '/orderManagement/createOrder',//统一的办理页面，后面的办理全用这个页面
             query: {openScreen: true, ...callData}
           })
           window.open(routeData.href, '_blank')*/
            _this.$router.push({
              path: "/orderManagement/createOrder", //统一的办理页面，后面的办理全用这个页面
              query: { openScreen: true, ...callData },
            });
          }
        });

      opcall.lib
        .event("busy")
        .unsubscribe()
        .subscribe(function(ext) {
          _this.seatPost = { ..._this.seatPost, ...ext, status: "忙线" };
          _this.refreshState = { ..._this.refreshState, isDial: true };
        });
      //接通事件
      opcall.lib
        .event("xfer_busy")
        .unsubscribe()
        .subscribe(function(ext) {
          _this.seatPost = { ..._this.seatPost, ...ext, status: "忙线" };
          console.log(
            "电话转接已经接通，事件类型：" +
              ext.event +
              "，来电号码" +
              ext.xfer_source +
              "，您的号码：" +
              ext.ext_no +
              "，第三方号码:" +
              ext.xfer_to +
              "转接随路:" +
              ext.xfer_info,
          );
        });
      opcall.lib
        .event("xfer_fail")
        .unsubscribe()
        .subscribe(function(ext) {
          _this.seatPost = { ..._this.seatPost, ...ext, status: "忙线" };
          console.log(
            "电话转接已经失败，来电号码" +
              ext.xfer_source +
              "，您的号码：" +
              ext.ext_no +
              "，第三方号码:" +
              ext.xfer_to,
          );
        });

      opcall.lib
        .event("available")
        .unsubscribe()
        .subscribe(function(ext) {
          opcall.lib.log("receive available");
          if (opcall.cfg.state.call_state == "idle") {
            _this.seatPost = { ..._this.seatPost, ...ext, status: "空闲" };
            _this.refreshState = { ..._this.refreshState, isLeisure: true };
          }
          console.log("收到坐席置闲信令：" + JSON.stringify(ext));
        });

      opcall.lib
        .event("unavailable")
        .unsubscribe()
        .subscribe(function(ext) {
          opcall.lib.log("receive unavailable:" + ext.state_cause_description);
          if (opcall.cfg.state.call_state == "idle") {
            //let desc = ext.state_cause_description ? ext.state_cause_description : (ext.state_cause == "pause" ? "话后" : "小休")
            //_this.$set(_this.seatPost, 'status', desc)
            _this.seatPost = {
              ..._this.seatPost,
              ...ext,
              status: ext.state_cause == "pause" ? "话后" : "小休",
            };
            _this.refreshState = { ..._this.refreshState, isLeisure: false };
          }
          console.log("收到坐席置忙信令：" + JSON.stringify(ext));
        });

      /**
       * 处理坐席保持事件
       */
      opcall.lib
        .event("hold")
        .unsubscribe()
        .subscribe(function(ext) {
          opcall.lib.log("receive hold");
          _this.seatPost = { ..._this.seatPost, ...ext, status: "电话保持" };
          console.log("收到坐席保持信令：" + ext.event);
        });

      /**
       * 转接成功
       */
      opcall.lib
        .event("bridge_success")
        .unsubscribe()
        .subscribe(function(ext) {
          console.log("拨打成功：" + JSON.stringify(ext));
        });

      /**
       * 转接失败
       */
      opcall.lib
        .event("bridge_fail")
        .unsubscribe()
        .subscribe(function(ext) {
          console.log("拨打失败：" + JSON.stringify(ext));
        });

      //被强制切换状态
      opcall.lib
        .event("force_agent_status")
        .unsubscribe()
        .subscribe(function(ext) {
          console.log("坐席状态被强制切换：" + JSON.stringify(ext));
        });

      //被强制退出
      opcall.lib
        .event("force_logout")
        .unsubscribe()
        .subscribe(function(ext) {
          console.log("坐席被强制退出：" + JSON.stringify(ext));
          _this.$message.error("坐席被强制退出");
          _this.seatPost = {};
          _this.refreshState = {
            isCheck: false, //是否登录
            isLeisure: false, //是否示闲
            isDial: false, //是否在通话中
            isHold: false, //是否保持
          };
          //手动签出
          window.localStorage.removeItem("seatPostLogin");
          //记录签出时间
          logout({ agentNo: sysSeatsConfig.loginExtNo });
        });

      /**
       * 调用超时事件
       */
      opcall.lib
        .event("call_timeout")
        .unsubscribe()
        .subscribe(function(ext) {
          opcall.lib.log("本次调用超时");
          _this.$message.error("话务条调用超时，请刷新页面");
        });

      /**
       * 处理分机离线事件
       */
      opcall.lib
        .event("offline")
        .unsubscribe()
        .subscribe(function() {
          opcall.lib.log("receive offline");
          _this.$set(_this.seatPost, "status", "分机离线");
          console.log("收到分机离线信令：");
        });
      return opcall;
    },
    //签入签出
    checkInOut(action) {
      if (action === "in") {
        //签入
        this.opcall.lib.startup();
        this.refreshState = { ...this.refreshState, isCheck: true };
      } else {
        //签出
        this.opcall.lib.stop();
        this.refreshState = { ...this.refreshState, isCheck: false };
      }
    },
    // 示闲示忙
    changeAgentStatus(action) {
      const _this = this;
      _this.opcall.cli.adv_agent_status("-", action, "", function(data) {
        _this.$message.info(data.message);
      });
    },
    //拨打
    dial(telPhoneNumber, explicitNumber) {
      const _this = this;
      if (telPhoneNumber) {
        _this.opcall.cli.dial(
          explicitNumber ? explicitNumber : "-",
          telPhoneNumber,
          function(data) {
            //_this.$message.info(data.message);
          },
        );
      } else {
        _this.$message.error("请选择被叫号码");
      }
    },
    //挂断
    hangup: function() {
      const _this = this;
      _this.opcall.cli.hangup("-", null, function(data) {
        //_this.$message.info(data.message);
      });
    },
    // 保持
    hold() {
      const _this = this;
      _this.opcall.cli.hold("-", null, function(data) {
        _this.refreshState = { ..._this.refreshState, isHold: true };
        //_this.$message.info(data.message);
      });
    },
    //恢复
    revert() {
      const _this = this;
      _this.opcall.cli.unhold("-", null, function(data) {
        //_this.$message.info(data.message);
        _this.refreshState = { ..._this.refreshState, isHold: false };
      });
    },
    //盲转
    blindTransfer(to) {
      const _this = this;
      if (to) {
        _this.opcall.cli.blind_transfer("-", to, function(data) {
          _this.$message.info(data.message);
        });
      } else {
        _this.$message.error("请选择被叫号码");
      }
    },
    //强插
    breakin(to) {
      const _this = this;
      if (to) {
        _this.opcall.cli.breakin(to, "-", function(data) {
          _this.$message.info(data.message);
        });
      } else {
        _this.$message.error("请选择被叫号码");
      }
      console.log("接回的号码", to);
    },
    //转接
    transfer(to, type) {
      const _this = this;
      if (to) {
        if (type == "three") {
          console.log("三方通话", to);
          _this.opcall.cli.set_var(
            "-",
            "threeway_call",
            "true",
            "both",
            function(data) {
              _this.opcall.cli.transfer("-", to, function(data) {
                console.log("三方通话data.message", data.message);
                _this.$message.info(data.message);
              });
            },
          );
          /* _this.opcall.cli.xfer2threeway( function(data){
             log(data.message);
           });*/
        } else {
          console.log("咨询转接", to);
          _this.opcall.cli.transfer("-", to, function(data) {
            log(data.message);
          });
        }
      } else {
        _this.$message.error("请选择被叫号码");
      }
    },
    //取消转接
    cancelTransfer() {
      const _this = this;
      _this.opcall.cli.cancelxfer(function(data) {
        _this.$message.info(data.message);
      });
    },
    //监听
    spy(to) {
      const _this = this;
      _this.opcall.cli.spy(to, "-", function(data) {
        _this.$message.info(data.message);
      });
    },
    //坐席状态列表:暂不使用
    async listAgent() {
      const _this = this;
      let list;
      _this.opcall.cli.list_agent(
        await function(data) {
          //console.log(JSON.stringify(data))
          //list = data.data
          //回调函数无法return list，写入localStorage
          //localStorage.setItem("agentList", JSON.stringify(data.data))
        },
      );
      return list;
    },
    //其它组件可调用该方法，进行电话操作
    controls({ type, obj = {}, callbackFn }) {
      switch (type) {
        case "initStrip":
          this.initStrip(obj.queueId);
          break;
        case "checkIn":
          this.checkInOut("in");
          break;
        case "checkOut":
          this.checkInOut("out");
          break;
        case "busy":
          this.changeAgentStatus("break3");
          break;
        case "leisure":
          this.changeAgentStatus("ready");
          break;
        case "dial":
          this.dial(obj.to, obj.from);
          break;
        case "hangup":
          this.hangup();
          break;
        case "hold":
          this.hold();
          break;
        case "revert":
          this.revert();
          break;
        case "hangup":
          this.hangup();
          break;
        case "blindTransfer":
          this.blindTransfer(obj.to);
          break;
        case "breakin":
          this.breakin(obj.to);
          break;
        case "transfer":
          this.transfer(obj.to);
          break;
        case "transferThree":
          this.transfer(obj.to, "three");
          break;
        case "cancelTransfer":
          this.cancelTransfer();
          break;
        case "spy":
          this.spy(obj.to);
          break;
      }
      callbackFn && callbackFn();
    },
    handleStorage(e) {
      console.log("storage-e:", e);
      /*     console.log('Key:', e.key);
            console.log('Old Value:', e.oldValue);
            console.log('New Value:', e.newValue);
            console.log('URL:', e.url);
            console.log('Storage Area:', e.storageArea);*/
      if (e.key == "seatPost") {
        const nVal = JSON.parse(e.newValue);
        this.seatPost = { ...nVal };
        this.$bus.$emit("setSoftTelStripData", { seatPost: nVal });
      }
      if (e.key == "refreshState") {
        const nVal = JSON.parse(e.newValue);
        this.refreshState = { ...nVal };
        this.$bus.$emit("setSoftTelStripData", { refreshState: nVal });
      }
    },
    /*handleTab(e) {
      if (document.visibilityState === 'visible') {
        // Tab已激活，执行相应操作
        // console.log('Tab已激活');
        this.autoLogin()
      }
    },*/
    /* async autoLogin() {
       /!*const refreshState = JSON.parse(window.localStorage.getItem("refreshState"))
       if (refreshState) {
         this.refreshState = {...refreshState}
       }*!/
     }*/
    /*beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler(e) {
      //判断是窗口关闭还是刷新
      this.unloadTime = new Date().getTime() - this.beforeUnloadTime
      if (this.unloadTime <= 5) {
        //关闭窗口：自动签出话务条，
        if (this.refreshState.isCheck) {
          this.$bus.$emit('controls', {type: 'checkOut',})
          window.localStorage.removeItem("seatPostLogin")
        }
      }
    }*/
  },
  watch: {
    seatPost: function(nVal, oVal) {
      //跨标签页通信
      // localStorage.setItem("seatPost", JSON.stringify(nVal))
      //当前标签
      //sessionStorage.setItem("seatPost", JSON.stringify(nVal))
      //任意组件通信
      //this.$bus.$emit('setSoftTelStripData', {seatPost: nVal})
      this.$store.dispatch("webphoneStrip/setSeatPostAction", nVal);
    },
    refreshState: function(nVal, oVal) {
      //跨标签页通信
      // localStorage.setItem("refreshState", JSON.stringify(nVal))
      //任意组件通信
      //this.$bus.$emit('setSoftTelStripData', {refreshState: nVal})
      this.$store.dispatch("webphoneStrip/setRefreshStateAction", nVal);
    },
    info: {
      handler(newValue, oldValue) {
        // 在数据变化时执行相应的操作
        const { sysSeatsConfig, sysCallCenterConfig } = newValue;
        if (
          newValue &&
          sysCallCenterConfig.configUrl &&
          sysSeatsConfig.userName &&
          sysSeatsConfig.loginQueue
        ) {
          this.$bus.$emit("controls", {
            type: "initStrip",
            obj: { queueId: sysSeatsConfig.loginQueue },
          });
          //签入话务条
          this.$bus.$emit("controls", { type: "checkIn" });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const _this = this;
    //on(window, 'beforeunload', e => this.beforeunloadHandler(e))
    //on(window, 'unload', e => this.unloadHandler(e))

    on(window, "resize", this.handleWindowResize);
    this.handleMatchMedia();
    //其它组件调用话务条方法
    this.$bus.$on("controls", this.controls);
    //跨标签页通讯
    // on(window, "storage", this.handleStorage);
    //tab标签激活 自动登录
    //on(document, "visibilitychange", this.handleTab);
    //自动重新登录话务条
    //this.autoLogin()
    //如果登录过（即页面点过签入），则直接自动重新登录
    const seatPostLogin = JSON.parse(
      window.localStorage.getItem("seatPostLogin"),
    );
    if (seatPostLogin != null && seatPostLogin.checkIn) {
      window.setTimeout(() => {
        //更新info信息：将queueId设置到sysSeatsConfig
        this.$store.dispatch("admin/user/set", {
          ..._this.info,
          sysSeatsConfig: {
            ..._this.info.sysSeatsConfig,
            loginQueue: seatPostLogin.queueId,
          },
        });
      }, 1000);
    }
    /*
      监听<websocket>推送的消息进行<windows>桌面消息推送
    */
    this.$bus.$on("updateNoticeMessage", (msg) => {
      let instanceNotification = Notification || window.Notification;
      // console.log(instanceNotification, 'instanceNotification');

      if (instanceNotification) {
        let permissionNow = instanceNotification.permission;
        if (permissionNow === "granted") {
          //允许通知
          creatNotification();
        } else if (permissionNow === "default") {
          setPermission();
        } else if (permissionNow === "denied") {
          console.log("用户拒绝了你!!!");
        } else {
          setPermission();
        }
      }

      function setPermission() {
        //请求获取通知权限
        instanceNotification.requestPermission(function(PERMISSION) {
          console.log(PERMISSION, "PERMISSION");
          if (PERMISSION === "granted") {
            console.log("用户允许通知了!!!");
            creatNotification();
          } else {
            console.log("用户拒绝了你!!!");
          }
        });
      }

      function creatNotification() {
        if (!window.Notification) {
          alert("浏览器不支持通知！");
          return false;
        }
        // console.log(window.Notification.permission);

        if (window.Notification.permission != "granted") {
          console.log("用户未开启通知权限!!!");
          return false;
        }

        let instanceNotification = new Notification(
          "您有一条工单消息，请及时处理！",
          {
            icon: require("@/assets/images/office/time1.png"),
            body: msg,
            requireInteraction: true,
          },
        );

        instanceNotification.onshow = function() {
          // console.log("显示通知");
          //3s后自动关闭通知
          // setTimeout(function () {
          //   instanceNotification.close()
          // }, 3 * 1000);
        };
        instanceNotification.onclick = function() {
          router.push("/orderManagement/todoOrder");
          instanceNotification.close();
        };
        instanceNotification.onclose = function() {
          console.log("通知关闭");
        };
        instanceNotification.onerror = function() {
          console.log("错误");
        };
      }
    });
  },
  beforeDestroy() {
    //清除绑定事件
    //off(window, 'beforeunload', e => this.beforeunloadHandler(e))
    //off(window, 'unload', e => this.unloadHandler(e))
    off(window, "resize", this.handleWindowResize);
    // off(window, "storage", this.handleStorage);
    //off(document, "visibilitychange", this.handleTab);
  },
};
</script>
<style lang="less">
body,
html {
  background-color: #f5f6f8;
}

.form-body {
  padding: 30px;
  background-color: #fff;
}

.el-form .el-form-item__label {
  color: #333;
}

.mb18 {
  margin-bottom: 18px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt20 {
  margin-top: 20px;
}

.ml10 {
  margin-left: 10px;
}

.mr10 {
  margin-right: 10px;
}

.mr5 {
  margin-right: 5px;
}

.is-plain.el-button {
  --el-button-bg-color: #fff;
}

.el-tabs__nav-wrap::after {
  content: "" !important;
  height: 0 !important;
}

.el-tabs__item {
  font-size: 16px;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}

.home-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 1rem;
  background-color: #fff;
}

.search-form {
  padding: 18px 18px 0 0;
  border: 1px dashed #3679ff66;
  border-radius: 4px;
}
// 按钮导入统一样式
.import-btn-container {
  position: relative;
  overflow: hidden;
  .import-file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 70px;
    height: 36px;
    opacity: 0;
    cursor: pointer;
  }
}
</style>
